import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { type Theme } from '@mui/material/styles';

export const GaugeContainer = styled(Stack)({
  alignItems: 'center',
  flex: 1,
  position: 'relative',
  marginTop: '48px',
  marginBottom: '8px',
});

export const GaugeIconContainer = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  position: 'absolute',
  top: -50,
  zIndex: 10,
});

export const GaugesRow = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '16px',
});

export const GaugeLabel = styled(Typography, {
  shouldForwardProp: (prop) =>
    !['$active', '$done', '$type'].includes(prop as string),
})<{ $active?: boolean; $done?: boolean; $type?: 'download' | 'upload' }>(
  ({
    theme,
    $active,
    $done,
  }: {
    theme: Theme;
    $active?: boolean;
    $done?: boolean;
    $type?: 'download' | 'upload';
  }) => ({
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '1px',
    textTransform: 'uppercase' as const,
    transition: 'color 0.3s ease',
    color: $active
      ? theme.palette.text.primary
      : $done
        ? theme.palette.white['06']
        : theme.palette.grey['01'],
  })
);

export const AccentLine = styled('div', {
  shouldForwardProp: (prop) => !['$active', '$type'].includes(prop as string),
})<{ $active?: boolean; $type?: 'download' | 'upload' }>(
  ({
    theme,
    $active,
    $type,
  }: {
    theme: Theme;
    $active?: boolean;
    $type?: 'download' | 'upload';
  }) => ({
    width: 50,
    height: 3,
    borderRadius: 2,
    transition: 'background 0.5s ease',
    background: $active
      ? $type === 'upload'
        ? `linear-gradient(90deg, ${theme.palette.secondary['04']}, ${theme.palette.primary.main})`
        : `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.status.online})`
      : theme.palette.grey['03'],
  })
);
